import React from "react";
//import { Link } from "react-router-dom";
//import { useUserSelector } from "../store/selectors/userSelector";

const Footer: React.FC = () => {
    //const user: any = useUserSelector();

    return (
        <div className="text-center bg-white pt-4 border-t border-[#dfdfdf]">
            <p className="text-[13px] text-[#222] m-0">&copy; Copyright Wine Match</p>
        </div>
    );
};

export default Footer;